const KEY = '19030410-2c5fe4ac9573efb3689b839da';
export default KEY;
